/**
 *
 * parseMeeting
 * Parse stringified videoMeeting.info
 * Add info to slots and meetings
 *
 */

import { get } from 'lodash-es';
import recursiveParse from 'utils/recursiveParse.js';
import setIn from 'utils/setIn.js';

function parseMeeting(meeting) {
  const path = 'videoMeeting.info';
  const videoInfo = get(meeting, path);
  return videoInfo ? setIn(meeting, path, recursiveParse(videoInfo)) : meeting;
}

export default parseMeeting;
